module.exports = __webpack_public_path__ + "img/BC.8cf0329a.svg";